import {DogStatus, LicenseStatus} from '@/types';

export const dogStatusChoices = [
    {id: DogStatus.PENDING, name: 'Pending', disabled: true},
    {id: DogStatus.APPROVED, name: 'Approved'},
    {id: DogStatus.REJECTED, name: 'Rejected'},
    {id: DogStatus.DRAFT, name: 'Draft', disabled: true},
];

export const dogStatusFilters = [
    {id: DogStatus.PENDING, name: 'Pending'},
    {id: DogStatus.APPROVED, name: 'Approved'},
    {id: DogStatus.REJECTED, name: 'Rejected'},
    {id: DogStatus.DRAFT, name: 'Draft'},
];

export const licenseStatusChoices = [
    {id: LicenseStatus.PENDING, name: 'Pending'},
    {id: LicenseStatus.APPROVED, name: 'Approved'},
    {id: LicenseStatus.REJECTED, name: 'Rejected'},
    {id: LicenseStatus.EXPIRED, name: 'Expired'},
];

export const sexChoices = [
    {id: 'male', name: 'Male'},
    {id: 'female', name: 'Female'},
];

/** Admin users list: `sex` query param = owner has at least one non-deleted dog of this sex (not user gender). */
export const adminUserDogSexFilterChoices = [
    {id: 'male' as const, name: 'At least one male dog'},
    {id: 'female' as const, name: 'At least one female dog'},
];

export const stateChoices = [
    {id: 'NSW', name: 'NSW'},
    {id: 'VIC', name: 'VIC'},
    {id: 'SA', name: 'SA'},
    {id: 'ACT', name: 'ACT'},
    {id: 'TAS', name: 'TAS'},
    {id: 'WA', name: 'WA'},
    {id: 'QLD', name: 'QLD'},
    {id: 'NT', name: 'NT'},
];

export const breederChoices = [
    {id: true, name: 'Registered'},
    {id: false, name: 'Not Registered'},
];
